import { useMemo } from 'react';

export const useMatchMedia = () => {
  const windowHeight = typeof window !== 'undefined' && window.innerHeight;
  const windowWidth = typeof window !== 'undefined' && window.innerWidth;

  return useMemo(() => {
    if (typeof window !== 'undefined') {
      const isTouchDevice = window?.matchMedia(
        '(pointer: coarse) and (hover: none)'
      ).matches;
      return {
        isMobile:
          isTouchDevice && window?.matchMedia('(max-width: 600px)').matches,
        isTablet:
          isTouchDevice && window?.matchMedia('(min-width: 600px)').matches,
        isTouchDevice,
      };
    } else {
      return {};
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowHeight, windowWidth]);
};
